@if (isROLE_SECURITY_ADMIN) {
  <div class="col-sm-12">
    <br />
    <h5>
      <div class="text-danger small">{{"Security administrators have no permissions to work with processes." | translate}}</div>
    </h5>
  </div>
}
@if (!isROLE_SECURITY_ADMIN) {
  <div class="row">
    <div class="col-sm-12">
      <h6 class="mb-2">{{ 'Available processes for user :' | translate }}
        <h6 class="badge cds-badge active text-bg-info m-0">
          <i class="fa fa-user"></i>
          {{showLoginUserName}}
        </h6>
      </h6>
    </div>
  </div>
}
@if (!isROLE_SECURITY_ADMIN) {
  <div class="row">
    <div class="col-sm-5">
      <div class="col-sm-12">
        <appspinner [startSpinner]="nodeService.showAppLoader"></appspinner>
      </div>
      <div class="col-sm-12">
        <div class="card cds-card-shadow p-3">
          @if (files1 && files1.length>0) {
            <div>
              @if (files1 && files1.length>0) {
                <p-treeTable [value]="files1" [columns]="cols" selectionMode="single" dataKey="name"
                  (onNodeSelect)="nodeSelect($event)" [tableStyle]="{'border':'none'}">
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr>
                      <td [ttRow]="rowNode" [ttSelectableRow]="rowNode">
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        @if (rowData.type=='installation') {
                          <img alt="i-installation"
                            src="assets/img/icon-coloured-installation.svg"
                            style="width: 20px; height: 20px;" />
                        }
                        @if (rowData.type=='group') {
                          <img alt="i-group"
                            src="assets/img/icon-coloured-group.svg" style="width: 20px; height: 20px;" />
                        }
                        @if (rowData.type=='institute') {
                          <img alt="i-organization"
                            src="assets/img/icon-coloured-organization.svg"
                            style="width: 20px; height: 20px;" />
                        }
                        @if (rowData.type=='process' && rowData.s1ProcessInfo) {
                          <img alt="i-process"
                            src="{{nodeService.getImageAgainstProcessStatus(rowData.s1ProcessInfo)}}"
                            style="width: 20px; height: 20px;" />
                        }
                        <span [ngStyle]="{'color': getColorForGroup(rowData.name), 'cursor' : getCursor(rowData) }">
                          @if (rowData.s1ProcessInfo) {
                            <span>({{rowData.s1ProcessInfo.revision}})</span>
                          }
                          {{rowData.name}}
                        </span>
                      </td>
                    </tr>
                  </ng-template>
                </p-treeTable>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col-sm-7">
      <app-process></app-process>
    </div>
  </div>
}